import axios from "@/api/axios";

const HIDE_LOADING = true;

//登录
export const login = data => axios({ 
  url: "/api/user/login",
  method: 'post',
  data,
});

// 注册
export const register = data => axios({ 
  url: "/api/user/register",
  method: 'post',
  data,
});
export const registerOTP = data => axios({ 
  url: "/api/user/sms/send/register",
  method: 'post',
  data,
});

// 区域码
export const queryAreaCode = data => axios({ url: "/api/sys/areaCode",  data, config: { noLoading: HIDE_LOADING } });

// 登出
export const logout = data => axios({ 
  url: "/api/user/logout",
  method: 'post',
  data,
});

// 忘记密码
export const forgetPwdOTP = data => axios({ 
  url: "/api/user/sms/send/resetLoginPwd",
  method: 'post',
  data,
});
export const forgetPwd = data => axios({ 
  url: "/api/reset/login/pwd",
  method: 'post',
  data,
});
// 修改密码
export const modifyLoginPwd = data => axios({ 
  url: "/api/user/modifyPassword",
  method: 'post',
  data,
});

// 用户信息
export const getUserInfo = data => axios({ url: "/api/user/profile",  data, config: { noLoading: HIDE_LOADING } });
export const queryAvatar = data => axios({ url: "/api/plat/avatar",  data });
export const queryUserAvatar = data => axios({ url: "/api/user/avatar",  data });
export const queryBadgeData = data => axios({ url: "/api/badge/data",  data });
export const updateAvatar = data => axios({ 
  url: "/api/user/modifyAvatar",
  method: 'post',
  data,
});

// 修改昵称
export const modifyNickname = data => axios({ 
  url: "/api/user/modifyNickname",
  method: 'post',
  data,
});

// uploadImg
export const uploadImg = data => axios({ 
  url: "/api/common/uploadImg",
  method: 'post',
  data,
});

// 设置
export const queryConfig = data => axios({ url: "/api/plat/setting",  data });

// 客服
export const customerSupport = data => axios({ url: "/api/customerSupport",  data });

//game
export const queryGameProvider = data => axios({ url: "/api/games/manuf",  data, config: { noLoading: HIDE_LOADING } });
export const queryGame = data =>  axios({ url: "/api/games/fetch",  data, config: { noLoading: true } });
export const queryGameHelper = data =>  axios({ url: "/api/games",  data, config: { noLoading: true } });

// 公告
export const queryNotice = data => axios({ url: "/api/open/notice/info",  data, config: { noLoading: HIDE_LOADING } });

//faq
export const queryFAQ = data => axios({ url: "/api/app/faq",  data, config: { noLoading: HIDE_LOADING } });

// insight
export const queryMyPost = data => axios({ url: "/api/user/post",  data });
export const querySightFollow = data => axios({ url: "/api/user/following",  data });
export const querySightTop = data => axios({ url: "/api/plat/todayTop",  data });
export const queryPostProvider = data => axios({ url: "/api/post/provider",  data }); // 厂商枚举
export const queryPostGame = data => axios({ url: "/api/post/game",  data }); // 游戏枚举
export const createPost = data => axios({ 
  url: "/api/post/create",
  method: 'post',
  data,
});

export const queryUserPost = data => axios({ url: "/api/post/fetch",  data });
export const queryUserProfile = data => axios({ url: "/api/profile/fetch",  data });
export const followUser = data => axios({ 
  url: "/api/profile/follow",
  method: 'post',
  data,
});
export const unfollowUser = data => axios({ 
  url: "/api/profile/unfollow",
  method: 'post',
  data,
});
export const likeUser = data => axios({ 
  url: "/api/profile/like",
  method: 'post',
  data,
});
